import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";
import Container from "../../Components/UI/Container";
import { useDebatesStatusStore, useUserStore } from "../../Context/store";
import {
  useDebateReadMutation,
  useGetSemiPublicDebateList,
} from "../../Web-Hooks/Debate/use-debate";
import Posts from "../Posts/Posts";

const ForumHome = () => {
  const location = useLocation();
  const { pathname } = location;
  const { user } = useUserStore();
  const forumId = pathname.slice(1).split("/")[1];
  const QueryKey = [
    "feed-subworkspace",
    user?.userId,
    forumId,
  ];

  // Infinite Query Hook
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useGetSemiPublicDebateList(
    user?.userId,
    forumId,
  );
  const { mutateAsync: readStatus, isPending } = useDebateReadMutation();

  const { currentForumStatus } = useDebatesStatusStore();

  const hasNewDebates =
    isLoading || isPending
      ? false
      : currentForumStatus?.sections?.semiPublicFeed;

  useEffect(() => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: forumId,
      sectionType: "semiPublic",
    });
  }, [readStatus, user?.userId, forumId]);

  const handleRefetch = async () => {
    readStatus({
      userId: user?.userId,
      subWorkSpaceId: forumId,
      sectionType: "semiPublic",
    });
    const response = await refetch();
    return response;
  };

  return (
    <Container>
      <InfiniteScroll
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        hasNewData={hasNewDebates}
        refetch={handleRefetch}
        queryKey={QueryKey}
      >
        <Posts
          apiType={pathname}
          user={user}
          isLoading={isLoading && !isFetchingNextPage}
          AllDebates={data?.pages?.flatMap((page) => page.debateList)} // Combine all pages
        />
      </InfiniteScroll>
    </Container>
  );
};

export default ForumHome;
